<template>
  <div class=" my-course-wrapper">
    <a-spin :spinning="loading">
      <div v-if="hasData">
        <course-item :loading="loading" :type="type" :data="queryList"></course-item>
      </div>
      <div v-else class="empty-content">
        <div class="d-flex justify-center ">
          <img class="empty-img" :src="empty" alt="">
        </div>
        <div class="text-center mt-4">没有可学习的课程，赶快联系机构报名吧~</div>
        <div class="d-flex justify-center">
          <a-button class="mt-4" shape="round" type="primary" @click="toApply">
            去报名
          </a-button>
        </div>

      </div>
    </a-spin>
  </div>
</template>

<script>

import empty from '@/assets/course_empty.png'
import courseItem from './courseItem.vue'
import { studentPlanclasses, studentOverdueclasses } from '@/api/myClass'
import { mapState } from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
export default {
  props: {
    type: {
      type: String,
      default: 'onTime'
    },
    planClassesId: {
      type: String,
      default: '0'
    },
    courseType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      empty,
      loading: true,
      hasData: true,
      activeCourseTab: undefined,
      activeSortTab: 1,
      searchValue: '',
      courseTabs: [
        {
          label: '全部',
          value: undefined
        },
        {
          label: '系统班',
          value: 1
        },

        {
          label: '公开课',
          value: 0
        },
      ],
      sortTabs: [
        {
          label: '默认',
          value: 1
        },
        {
          label: '最近学习',
          value: 2
        },

      ],

      allList: [],
      queryList: []
    }
  },
  components: {
    courseItem
  },
  computed: {
    ...mapState({
      planclassesId: state => state.course.planclassesId
    })
  },
  created () {
    this.getData().then(() => {
      // this.queryData()
    })
  },
  mounted () {

  },
  watch: {
    activeCourseTab () {
      this.getData().then(() => {
        this.queryData()
      })
    },
    'planclassesId' (old, val) {
      const token = Vue.ls.get(ACCESS_TOKEN)
      if (token !== null && old !== val) {
        this.getData().then(() => {
          // this.queryData()
          console.log('this.queryList', this.queryList)
        })
      }
    }
  },
  methods: {
    getData () {
      if (this.courseType === 'overdue') {
        return studentOverdueclasses({ disActive: 1 }).then(res => {
          console.log('resdsafsadfasf', res)
          this.queryList = []
          if (res) {
            this.hasData = true
            this.allList = res
            this.queryList = res
          } else {
            this.hasData = false
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        return studentPlanclasses({ planclassesId: this.planclassesId }).then(res => {
          // console.log('res', res)
          this.queryList = []
          if (res) {
            this.hasData = true
            this.allList = res
            if (this.allList.subjectList.length > 1) {
              this.allList.subjectList.forEach(el => {
                console.log(el.classesList)
                this.queryList.push(...el.classesList)
              })
            } else {
              this.queryList = this.allList.subjectList[0].classesList
            }
            console.log(this.queryList, 'queryListqueryListqueryList mycourse')
          } else {
            this.hasData = false
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    queryData () {
      let ary = []
      if (this.planClassesId !== '0') {
        console.log(this.planClassesId, this.allList)
        ary = this.allList.filter(item => item.planclassesId && item.planclassesId.indexOf(this.planClassesId) > -1)
      } else {
        ary = this.allList
      }
      this.queryList = ary
      this.queryList.sort(function (a, b) {
        console.log(a.lastWatchTime, b.lastWatchTime)
        if (!a.lastWatchTime) {
          return 1
        }
        if (!b.lastWatchTime) {
          return -1
        }
        return a.lastWatchTime < b.lastWatchTime ? 1 : -1
      })
      this.$forceUpdate()
    },
    onSearch () {
      this.queryData()
    },
    courseTabsChange (item) {
      this.activeCourseTab = item.value
      this.queryData()
    },
    sortTabsChange (item) {
      item.value === 2 && this.queryList.sort(function (a, b) {
        console.log(a.lastWatchTime, b.lastWatchTime)
        if (!a.lastWatchTime) {
          return 1
        }
        if (!b.lastWatchTime) {
          return -1
        }
        return a.lastWatchTime < b.lastWatchTime ? 1 : -1
      })
      item.value === 1 && this.getData().then(() => {
        this.queryData()
      })
      this.$forceUpdate()
      this.activeSortTab = item.value
    },
    toExpireCourse () {
      this.$router.push({
        name: 'expireCourse'
      })
    },
    toApply () {
      this.$router.push({
        name: 'contact',
       query: { ocode: Vue.ls.get('code') },
      })
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .ant-input {
  border-radius: 50px;
  overflow: hidden;
}

::v-deep .ant-input-search-button {
  border-radius: 50px;
  overflow: hidden;
}

.my-course-wrapper {
  height: 100%;
}

.overdue {
  cursor: pointer;
  color: #1564ff;
}

.header {
  height: 130px;
}

.tab-item {
  padding: 0 15px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}

.tab-item-acitve {
  border-radius: 50px;
  background-color: #1564ff;
  color: #fff;
  overflow: hidden;
}

.bar-title {
  color: #5e668d;
}

.empty-img {
  width: 150px;
}
</style>
